import { FC, useEffect } from 'react';

import { useRouter } from 'expo-router';

import DrawerPage from 'components/layout/drawer-page';
import LoyaltyLoader from 'pages/loyalty/loyalty-loader/loyalty-loader';
import { useAuthContext } from 'state/auth';
import { routes } from 'utils/routing';

import { useLoyaltyUserState } from '../../../../../state/loyalty/hooks/use-loyalty-user-state';
import { isActiveWalmartUser } from '../../../../../state/loyalty/hooks/utils/walmart';

export const WalmartRedirect: FC<React.PropsWithChildren<{}>> = () => {
  const { isAuthenticated, loading } = useAuthContext();
  const { loyaltyUser, loading: loyaltyLoading } = useLoyaltyUserState({
    refreshOnMountOrFocus: true,
  });
  const router = useRouter();

  useEffect(() => {
    const isAlreadyLinked = isActiveWalmartUser(loyaltyUser);
    if (!loading && !loyaltyLoading) {
      if (!isAuthenticated || !isAlreadyLinked) {
        router.navigate(`${routes.walmart}?type=distro`);
      } else {
        router.replace(routes.loyaltyOfferList);
      }
    }
  }, [isAuthenticated, loading, loyaltyLoading, loyaltyUser, router]);

  return (
    <DrawerPage>
      <LoyaltyLoader />
    </DrawerPage>
  );
};
